var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.308 4.328a1.65 1.65 0 0 0-2.34.38l-7.784 10.964-4.288-4.47a1.644 1.644 0 0 0-2.367-.075 1.736 1.736 0 0 0-.073 2.42s5.209 5.566 5.957 6.125a1.65 1.65 0 0 0 2.341-.38L20.68 6.724a1.74 1.74 0 0 0-.372-2.396"
  })));
};
export default SvgCheck;